import React, { Fragment } from "react";
import Bluecta from "../../layouts/Bluecta";
import Gallery from "./Gallery";
import Info from "./Info";
import Services from "./Services";
import BsInfo from "./Bsinfo";
import { useTranslation } from "react-i18next";

const DistressContent = () => {
  const { t } = useTranslation()
    let data = {
        title:t("Help With Distress Home"),
        para:t("Don’t walk away"),
        li1:t("Let us help you"),
        picture:"/assets/img/listings-list/distress.jpg"
    }

  return (
    <Fragment>
      <BsInfo data={data}  />
      <Services />
      <Gallery />
      <div className="section pt-0">
        <Bluecta />
      </div>
    </Fragment>
  );
};

export default DistressContent;
